import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../../../../components/link/Anchor';

const OpenCsInquiryQuestion = (props) => {
  const { text, question, answer, memo, toggleModal } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text)) {
    return '';
  }

  return (
    <Anchor
      color="primary"
      isUnderLine
      text={text}
      onClick={() =>
        toggleModal({
          name: ['csInquiryQuestionModal'],
          isOpen: true,
          data: {
            question,
            answer,
            memo,
          },
        })
      }
    />
  );
};

export default OpenCsInquiryQuestion;
